import axiosInstance from '../utils/axios.instance';
import { API_ENDPOINTS } from '../config/api.config';

/**
 * Service de gestion des archives
 */
export const archiveService = {
  /**
   * Liste de toutes les archives avec pagination et filtres
   * @param {Object} params - Paramètres de pagination et filtres
   * @returns {Promise}
   */
  getArchives: async (params = {}) => {
    try {
      const response = await axiosInstance.get(API_ENDPOINTS.ARCHIVES.LIST, { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Détails d'une archive
   * @param {number} archiveId
   * @returns {Promise}
   */
  getArchiveById: async (archiveId) => {
    try {
      const response = await axiosInstance.get(API_ENDPOINTS.ARCHIVES.BY_ID(archiveId));
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Créer une nouvelle archive
   * @param {Object} archiveData
   * @returns {Promise}
   */
  createArchive: async (archiveData) => {
    try {
      const response = await axiosInstance.post(API_ENDPOINTS.ARCHIVES.CREATE, archiveData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Modifier une archive
   * @param {number} archiveId
   * @param {Object} archiveData
   * @returns {Promise}
   */
  updateArchive: async (archiveId, archiveData) => {
    try {
      console.log('🌐 archiveService.updateArchive - ID:', archiveId);
      console.log('🌐 archiveService.updateArchive - archiveData type:', archiveData.constructor.name);
      console.log('🌐 archiveService.updateArchive - est FormData:', archiveData instanceof FormData);

      if (archiveData instanceof FormData) {
        console.log('🌐 Contenu du FormData envoyé au backend:');
        for (let pair of archiveData.entries()) {
          if (pair[1] && typeof pair[1] === 'object' && 'name' in pair[1] && 'size' in pair[1]) {
            console.log('   📎', pair[0], ':', pair[1].name, '(', pair[1].size, 'bytes)');
          } else {
            console.log('   ', pair[0], ':', pair[1]);
          }
        }
      }

      const response = await axiosInstance.put(
        API_ENDPOINTS.ARCHIVES.UPDATE(archiveId),
        archiveData
      );

      console.log('🌐 Réponse reçue du backend:', response.data);

      return response.data;
    } catch (error) {
      console.error('🌐 Erreur lors de l\'update:', error);
      throw error;
    }
  },

  /**
   * Supprimer une archive
   * @param {number} archiveId
   * @returns {Promise}
   */
  deleteArchive: async (archiveId) => {
    try {
      const response = await axiosInstance.delete(API_ENDPOINTS.ARCHIVES.DELETE(archiveId));
      return response;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Publier une archive (ADMIN)
   * @param {number} archiveId
   * @returns {Promise}
   */
  publishArchive: async (archiveId) => {
    try {
      const response = await axiosInstance.patch(API_ENDPOINTS.ARCHIVES.PUBLISH(archiveId));
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Archiver une archive (ADMIN)
   * @param {number} archiveId
   * @returns {Promise}
   */
  archiveArchive: async (archiveId) => {
    try {
      const response = await axiosInstance.patch(API_ENDPOINTS.ARCHIVES.ARCHIVE(archiveId));
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Rechercher des archives
   * @param {string} query - Terme de recherche
   * @param {Object} params - Paramètres additionnels
   * @returns {Promise}
   */
  searchArchives: async (query, params = {}) => {
    try {
      const response = await axiosInstance.get(API_ENDPOINTS.ARCHIVES.SEARCH, {
        params: { q: query, ...params },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Mes archives
   * @param {Object} params - Paramètres de pagination et filtres
   * @returns {Promise}
   */
  getMyArchives: async (params = {}) => {
    try {
      const response = await axiosInstance.get(API_ENDPOINTS.ARCHIVES.MY_ARCHIVES, { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Archives par catégorie
   * @param {number} categoryId
   * @param {Object} params - Paramètres de pagination
   * @returns {Promise}
   */
  getArchivesByCategory: async (categoryId, params = {}) => {
    try {
      const response = await axiosInstance.get(API_ENDPOINTS.ARCHIVES.BY_CATEGORY(categoryId), {
        params,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default archiveService;
